export default "__VITE_ASSET__B5bS8raN__"